import router from './router'

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});




// WEBPACK FOOTER //
// ./src/permission.js